import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idUnidadDeMedida: Yup.string().required(),
  equivalencia: Yup.number()
    .min(1)
    .required()
})
